import { trackEvent } from "./index";

export const trackComponentCreateInit = () => {
    trackEvent("cmp_create_init", {
    });
};